import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import * as authApi from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [actor, setActor] = useState(null); // { profile, role, actorType }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('afp_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .fetchMe()
      .then((res) => {
        setActor({ profile: res.profile, role: res.role, actorType: res.actorType });
      })
      .catch(() => {
        localStorage.removeItem('afp_token');
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authApi.login(email, password);
    localStorage.setItem('afp_token', res.token);
    setActor({ profile: res.profile, role: res.role, actorType: res.actorType });
    return res;
  }, []);

  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } catch {
      // ignore network errors on logout - we still clear local state below
    }
    localStorage.removeItem('afp_token');
    setActor(null);
  }, []);

  return (
    <AuthContext.Provider value={{ actor, loading, login, logout, setActor }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
